import { render, staticRenderFns } from "./RelatedItemsModule.vue?vue&type=template&id=1dd2362c&"
import script from "./RelatedItemsModule.ts?vue&type=script&lang=ts&"
export * from "./RelatedItemsModule.ts?vue&type=script&lang=ts&"
import style0 from "./RelatedItemsModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports